module.exports = __webpack_public_path__ + "static/media/clock-regular_1.0638ddee.svg";